import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import { Link } from 'react-router-dom'
import { config } from '../config'

const RefresherPage = () => {

    const data = [
        {
            title: "Refresher lessons ",
            desc: "Whether you want to expand your expertise, or if you’re just a bit rusty, we can cater refresher lessons to your needs. If you want to improve your night-time, all-weather, urban or rural driving, we’ll be able to help. "
        },
        {
            title: "Pass Plus",
            desc: "This is a 6-hour course recognised by the Driver and Vehicle Standards Agency (DVSA), aimed to enhance driving ability. You’ll develop existing skills while also learning new ones – becoming a safer, more courteous driver with increased road awareness. "
        },
        {
            title: "Motorway driving lessons ",
            desc: "Although learners in England, Scotland and Wales have been allowed on motorways since 2018, there’s always room for more practice. If you’d like to master motorway and dual carriageway driving, speak to us today. "
        }
    ]

    return (
        <>

            <Bredcrum
                heading={'Refresher driver lessons'}
                path={[
                    { name: 'Refresher driver lessons', path: 'refresher-driver-lessons' },
                ]}
            />

            <section className='py-5' style={{ backgroundColor: "#f6f6f7" }}>
                <div className='auto-container'>
                    <div className="sec-title centred">
                        <h2 className='text-capitalize'>Our advanced driving courses</h2>
                    </div>

                    <div>
                        <div class="btn-box mb-5 text-center">
                            <Link to={`${config.appUrl}book-a-lesson`}
                                className="theme-btn btn-one text-white" >
                                Get Couse prices and book
                            </Link>
                        </div>
                    </div>

                    <div className='row'>
                        {
                            data.map((course, i) => {
                                return (
                                    <CourseCard key={i} course={course} />
                                )
                            })
                        }
                    </div>

                    
                </div>
            </section>
        </>
    )
}


const CourseCard = ({ course }) => {
    return <div className="col-md-4 mb-4">
        <div className='b-white card rounded-0 border-0 shadow-sm p-4' style={{ minHeight: "280px" }}>
            <h5 className='text-green fw-bold'> {course.title} </h5>
            <p className='mt-3'>
                {course.desc}
            </p>
        </div>
    </div>
}

export default RefresherPage